// ==============================|| OVERRIDES - PAGINATION ITEM ||============================== //

export default function PaginationItem() {
  return {
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          margin: "3px",
        },
      },
    },
  };
}
